import React from "react"
import { useSelector, } from "react-redux"
import { Helmet, } from "react-helmet"
import Loading from "../../layouts/Loading"

export default function GamesComponent() {
  const state = useSelector(state => ({
    auth: state.auth,
  }))

  if (state.auth.loading) {
    return <div className="container home-container text-center">
      <Helmet>
        <title>Games - {process.env.REACT_APP_NAME}</title>
      </Helmet>
      <Loading/>
    </div>
  }

  return (
		<div className="container home-container">
			<Helmet>
				<title>Games - {process.env.REACT_APP_NAME}</title>
			</Helmet>
			<div className="page-inner">
				<div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
					<div>
						<h3 className="fw-bold mb-3">Games</h3>
						<h6 className="op-7 mb-2">Oversee your games history</h6>
					</div>
        </div>
      </div>
    </div>
  )
}
